export const CALCULATIONS_CUSTOM_ELEMENTS = {
    'CALCULATIONS.COLUMN.ACTIONS': 'Acțiuni',
    'CALCULATIONS.COLUMN.ELEMENT_NAME': 'Denumire element',
    'CALCULATIONS.COLUMN.VALUE': 'Valoare',
    'CALCULATIONS.COLUMN.COMMENTS': 'Comentarii',
    'CALCULATIONS.VALIDATION.SAVE_CHANGES': 'Vă rugăm să salvați modificările',
    'CALCULATIONS.VALIDATION.DESCRIPTION_MAX_LENGTH': 'Denumirea elementului trebuie să fie de maxim 200 de caractere',
    'CALCULATIONS.VALIDATION.INSERT_NAME': 'Introduceți denumirea elementului',
    'CALCULATIONS.VALIDATION.DUPLICATE': 'Această denumire este folosită pentru un alt element'
};
